var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapContainer",staticClass:"full-width google-map-height",class:_vm.confirmedPageDesktop ? 'confirmed-page-map-height' : ''},[(_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_vm._v("Loading map...")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"error-overlay"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }